'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/*const SimpleButton = ({children, whenClicked, classNames, themePrefix, ...rest }) =>*/
//(
//<button
//onClick   = {whenClicked}
//className = {`${classNames} ${themePrefix}-${JSON.parse(sessionStorage.websiteConfig).theme}`}
//type      = "button"
//{...rest}
//>
//{children}
//</button>
/*);*/

var SimpleButton = function SimpleButton(_ref) {
    var children = _ref.children,
        whenClicked = _ref.whenClicked,
        classNames = _ref.classNames,
        inputType = _ref.inputType,
        showSpinner = _ref.showSpinner,
        spinText = _ref.spinText,
        rest = _objectWithoutProperties(_ref, ['children', 'whenClicked', 'classNames', 'inputType', 'showSpinner', 'spinText']);

    return _react2.default.createElement(
        'button',
        _extends({
            onClick: whenClicked,
            className: '' + classNames,
            type: inputType ? inputType : "button",
            disabled: showSpinner
        }, rest),
        showSpinner ? _react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin' }) : null,
        showSpinner ? ' ' + spinText : children
    );
};

SimpleButton.propTypes = {
    whenClicked: _propTypes2.default.func,
    classNames: _propTypes2.default.string.isRequired,
    showSpinner: _propTypes2.default.bool,
    spinText: _propTypes2.default.string
};

exports.default = SimpleButton;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/SimpleButton.jsx
// module id = 475
// module chunks = 0